import React from 'react';
import { Shield, Lock, Eye, AlertTriangle } from 'lucide-react';

const SecurityFeatures = () => {
  const features = [
    {
      icon: <Shield size={16} />,
      title: 'Secure Reset',
      description: 'Your reset link is encrypted and expires after one use'
    },
    {
      icon: <Lock size={16} />,
      title: 'Password Encryption',
      description: 'Your new password is encrypted and stored securely'
    },
    {
      icon: <Eye size={16} />,
      title: 'Privacy Protected',
      description: 'Your personal information is never shared or stored'
    },
    {
      icon: <AlertTriangle size={16} />,
      title: 'Account Security',
      description: 'We\'ll notify you of any suspicious activity'
    }
  ];

  return (
    <div className="mt-6 p-4 bg-accent-50 rounded-lg border border-accent-200">
      <h3 className="text-sm font-semibold text-accent-800 mb-3">
        Security Features
      </h3>
      <div className="grid grid-cols-1 gap-3">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start">
            <div className="text-accent-600 mr-3 mt-0.5">
              {feature.icon}
            </div>
            <div>
              <h4 className="text-xs font-medium text-accent-700">
                {feature.title}
              </h4>
              <p className="text-xs text-accent-600 mt-0.5">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityFeatures;